import SidebarLink from "@/components/sidebar/link/SidebarLink.vue";
import { collapsed, toggleSidebar, sidebarWidth, isMobile } from './state'
import store from "../../../store/index.js";

export default {
    props: {},
    components: { SidebarLink },
    data () {
        return {
            loading: false,
            error: null,
            collapsed,
            sidebarWidth,
            toggleSidebar,
            isMobile
        }
    },
    computed: {
        groupedMenu() {
            const routes = this.$router.options.routes
            const result = {}

            routes.forEach(route => {
                if (!route.meta?.isMenuItem) return

                const hasAccess =
                    route.meta.permissions === null ||
                    store.getters.hasPermission(route.meta.permissions)

                if (!hasAccess) return

                const section = route.meta.section || ''

                if (!result[section]) {
                    result[section] = []
                }

                result[section].push(route)
            })

            const order = ['', 'ADMIN']

            return Object.keys(result)
                .sort((a, b) => order.indexOf(a) - order.indexOf(b))
                .reduce((acc, key) => {
                    acc[key] = result[key]
                    return acc
                }, {})
        },

        activeParent() {
            return this.$route.meta?.parentPath;
        },
    },

    methods: {
        formatSection(section) {
            if (!section) return ''
            return section.toUpperCase() + ' SECTION'
        },

        async logout() {
            this.loading = true
            try {
                const response = await this.ApiRequest.requestAsync(
                    'logout',
                    this.ApiRequest.REQUEST_POST,
                    [],
                    'logout',
                    false
                );

                if (response.error) {
                    this.error = response.validationErrors || response.messageCodes;
                } else {
                    sessionStorage.clear();
                    localStorage.clear();
                    this.$router.go();
                }
            } catch (error) {
                console.error('Logout error:', error);
            } finally {
                this.loading = false;
            }
        },

        getSubmenu(rowPath) {
            const parent = this.$router.options.routes.find(
                r => r.meta?.isMenuItem && r.path === rowPath
            );

            return parent?.children?.filter(el =>
                el.meta?.isMenuItem &&
                (el.meta?.permissions === null ||
                    store.getters.hasPermission(el.meta.permissions))
            ) || [];
        },

        handleClick() {
            if (this.isMobile) {
                this.collapsed = true
            }
        }
    },

    watch: {
        collapsed(val) {
            if (this.isMobile) {
                document.body.style.overflow = val ? 'auto' : 'hidden'
            }
        }
    }
}